// @flow

import { setProps } from '../props';
import { setEditable } from '../State/editable';

import fetchEstimate from '../Services/fetchEstimate';

import fetchEstimateStatuses from '../../../Core/Services/fetchEstimateStatuses';
import fetchEstimateTenderStatuses from '../../../Core/Services/fetchEstimateTenderStatuses';
import fetchEstimateLatestActions from '../../../Core/Services/fetchEstimateLatestActions';
import fetchServiceTypes from '../../../Core/Services/fetchServiceTypes';
import fetchUsers from '../../../Core/Services/fetchUsers';

export default (props: any) => async (dispatch: Function) => {

  setProps(props);

  // Check if this is a newly created estimate
  const urlParams = new URLSearchParams(window.location.search);
  const isNewEstimate = urlParams.get('new') === 'true';

  if (isNewEstimate) {
    // Automatically enable edit mode for newly created estimates
    dispatch(setEditable(true));
    
    // Remove the 'new' parameter from URL to clean it up
    urlParams.delete('new');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState({}, '', newUrl);
  }

  dispatch(fetchEstimate());

  dispatch(fetchEstimateStatuses());
  dispatch(fetchEstimateTenderStatuses());
  dispatch(fetchEstimateLatestActions());
  dispatch(fetchServiceTypes());
  dispatch(fetchUsers());

}